import * as Case from 'case';
import { BannerComponent } from '~contentful/components/banner/banner.component';
import { ButtonModel } from '~contentful/models/components/button.model';
import { ComponentModel } from '~contentful/models/components/component.model';
import { ResponsiveImageModel } from '~contentful/models/components/responsive-image.model';
import { RichTextModel } from '~contentful/models/core/rich-text.model';

export class BannerModel extends ComponentModel {
    public readonly name: string;
    public readonly image?: ResponsiveImageModel;
    public readonly backgroundColor?: string;
    public readonly theme?: string;
    public readonly content: RichTextModel;
    public readonly button1: ButtonModel;
    public readonly button2: ButtonModel;
    public readonly componentClass = BannerComponent;

    public get contextLabel() {
        return this.name;
    }

    public get contextValue() {
        return Case.kebab(this.name);
    }
}
